import { AutoComplete } from "primereact/autocomplete";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import storage from "../../Services/Storage";
import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import * as Fa from "react-icons/fa";
import { Link, useLocation, useNavigate, useSearchParams } from "react-router-dom";
import {
    createAPIEndpointSalesDiscountAllocation,
    EndpointSalesDiscountAllocation,
} from "../../Services/SalesDiscountAllocation/SalesDiscountAllocationService";
import Loader from "../../Components/Loader";
import { Dialog } from "primereact/dialog";
import { PickList } from "primereact/picklist";
// import { classNames } from "primereact/utils";
// import { string } from "yup";
// import { use } from "react";

const SalesDiscountAllocation = () => {
    const nav = useNavigate();
    const [searchParam] = useSearchParams();
    const location = useLocation();
    const data = location.state;
    const auth = storage.getLocal("user");
    const [priceListNumber, setPriceListNumber] = useState(null);
    const [selectedPriceListNumber, setSelectedPriceListNumber] = useState(null);
    const [filteredPriceListNumber, setFilteredPriceListNumber] = useState([]);
    const [discountName, setDiscountName] = useState([]);
    const [selectedDiscountName, setSelectedDiscountName] = useState(null);
    const [filteredDiscountName, setFilteredDiscountName] = useState([]);
    const [customerData, setCustomerData] = useState([]);
    // const [selectSaveData, setSelectSaveData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    // const [selectRow, setSelectRow] = useState([]);
    const [source, setSource] = useState([]);
    const [target, setTarget] = useState([]);
    const [custPopUp, setCustPopUp] = useState(false);
    const PRICE_LIST_ID = searchParam.get("PRICE_LIST_ID");
    const DISCOUNT_ID = searchParam.get("DISCOUNT_ID");
    const Type = searchParam.get("Type");

    const getPriceList = async () => {
        setIsLoading(true);
        try {
            const response = await createAPIEndpointSalesDiscountAllocation().get(
                `${EndpointSalesDiscountAllocation.GetAllPriceListData}`
            );
            setPriceListNumber(response.data);
            setIsLoading(false);
        } catch (err) {
            console.log("error ", err);
            setIsLoading(false);
        }
    };

    const getDiscountNameList = async () => {
        setIsLoading(true);
        try {
            const res = await createAPIEndpointSalesDiscountAllocation().get(
                `${
                    EndpointSalesDiscountAllocation.GetAllDiscountData
                }?PLNo=${selectedPriceListNumber}&DiscId=${""}&CompId=${auth.CompId}`
            );
            setDiscountName(res.data);
            setIsLoading(false);
        } catch (err) {
            console.log("err ", err);
            setIsLoading(false);
        }
    };
    const DeleteCustDetailsData = async (data) => {
        setIsLoading(true);
        try {
            if(Type==="New"){
                const filterCust = customerData.filter((val)=>{return val.MASK_CUST_ID!==data.MASK_CUST_ID;});
                setCustomerData(filterCust);
                const filterTarget = target.filter((val)=>{return val.MASK_CUST_ID!==data.MASK_CUST_ID;});
                setTarget(filterTarget);
            }
            else if(Type==="View"){
                const res = await createAPIEndpointSalesDiscountAllocation().post(
                    `${EndpointSalesDiscountAllocation.DeleteCustDetailsData}?PLNo=${selectedPriceListNumber.MASK_PRICE_LIST_ID}&DiscountId=${selectedDiscountName.MASK_DISCOUNT_ID}&CustId=${encodeURIComponent(data.MASK_CUST_ID)}&UsrId=${auth.UserId}&CompId=${auth.CompId}`
                );
                if(res.data.IsSaved==true){
                    console.log(res,"DeleteCustDetailsData");
                    const filterCust = customerData.filter((val)=>{return val.MASK_CUST_ID!==data.MASK_CUST_ID;});
                    setCustomerData(filterCust);
                    const filterTarget = target.filter((val)=>{return val.MASK_CUST_ID!==data.MASK_CUST_ID;});
                    setTarget(filterTarget);
                    toast.error("Record Deleted Successfully", {
                        position: toast.POSITION.TOP_CENTER,
                        pauseOnFocusLoss: false,
                        closeButton: false,
                        autoClose: 2000,
                    });
                }
            }
        } catch (err) {
            console.log("error has been occured ", err);
        } finally {
            setIsLoading(false);
        }
    };

    const getCustomerData = async () => {
        setIsLoading(true);
        try {
            const res = await createAPIEndpointSalesDiscountAllocation().get(
                `${EndpointSalesDiscountAllocation.GetCustDetailsData}?PLNo=${PRICE_LIST_ID}&DiscId=${DISCOUNT_ID}&CompId=${auth.CompId}`
            );
            const modifiedData = res.data.map((item) => ({
                ...item,
                isSelected: true,
            }));
            setCustomerData(modifiedData);
            let obj = res.data.map((a)=>({
                CUST_CODE:a.CUST_CODE,
                CUST_NAME:a.CUST_NAME,
                MASK_COMP_CODE:a.MASK_COMP_CODE,
                MASK_COMP_NAME:a.MASK_COMP_NAME,
                MASK_CUST_ID:a.MASK_CUST_ID,
                mask_iukey:a.MASK_IUKEY
            }));
            setTarget(obj);
        } catch (err) {
            console.log("error ", err);
        }finally{
            setIsLoading(false);
        }
    };

    //   const getFilteredCustomerData = async () => {
    //     try {
    //       const res = await createAPIEndpointSalesDiscountAllocation().get(
    //         `${EndpointSalesDiscountAllocation.GetFilteredCustomerData}?CustId=${auth.UserId}&PLNo=${selectedPriceListNumber?.PRICE_LIST_NO}&CompId=${auth.CompId}`
    //       );
    //       const modifiedData = res.data.map((item) => ({
    //         ...item,
    //         isSelected: false,
    //       }));
    //       setCustomerData((prev) => [...prev, ...modifiedData]);
    //     } catch (err) {
    //       console.log("error ", err);
    //     }
    //   };

    const createPayload = () => {
        console.log(customerData,"createPayload");
        return {
            obj: customerData.map((item) => {
                return {
                    compId: auth.CompId,
                    userId: auth.UserId,
                    itemId: item.MASK_CUST_ID,
                    allocationBasic: "C",
                    discountId: selectedDiscountName?.MASK_DISCOUNT_ID,
                    priceListId: selectedPriceListNumber?.MASK_PRICE_LIST_ID,
                    status: "Y",
                    iuKey: item.mask_iukey,
                };
            }),
        };
    };

    const saveData = async () => {
        
        console.log(selectedPriceListNumber,selectedDiscountName,customerData,"selectedPriceListNumber");
        if (selectedPriceListNumber===null) {
            toast.error("Please Select a price list", {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 2000,
            });
            return;
        }
        if (selectedDiscountName===null) {
            toast.error("Please Select a discount", {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 2000,
            });
            return;
        }
        if (customerData.length === 0) {
            toast.error("Please select at least one customer", {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 2000,
            });
            return;
        }

        try {
            setIsLoading(true);
            const payload = createPayload();
            console.log(payload,"payload");
            // return;
            await createAPIEndpointSalesDiscountAllocation().post(
                `${EndpointSalesDiscountAllocation.SaveData}`,
                payload.obj
            );
            toast.success("Data saved successfully!", {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 2000,
            });
            nav("/masters/salesdiscountallocation");
        } catch (err) {
            console.log("Error ", err);
            toast.error(err?.response?.data?.Message, {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 2000,
            });
        } finally {
            setIsLoading(false);
        }
    };

    const filterPriceListNumber = (event) => {
        let query = event.query.toLowerCase();
        let filtered = priceListNumber.filter((item) =>
            item.PRICE_LIST_NO.toLowerCase().includes(query)
        );
        setFilteredPriceListNumber(filtered);
        // getDiscountNameList();
    };

    const filterDiscountName = (event) => {
        let query = event.query.toLowerCase();
        let filtered = discountName.filter((item) =>
            item.DISCOUNT_NAME.toLowerCase().includes(query)
        );
        setFilteredDiscountName(filtered);
    };
    useEffect(() => {
        setPriceListNumber([]);
        if(Type==="View"){
            getCustomerData();
        }
        else{
            getPriceList();
            getDiscountNameList();
        }
    // getFilteredCustomerData();
    }, []);

    // useEffect(() => {
    //     const initiallySelectedRows = customerData.filter((row) => row.isSelected);
    //     setSelectRow(initiallySelectedRows);

    // }, [customerData]);

    // useEffect(() => {
    //     if (selectedDiscountName && selectedPriceListNumber) {
    //         getCustomerData();
    //         getFilteredCustomerData();
    //     }
    // }, [selectedDiscountName, selectedPriceListNumber]);

    useEffect(() => {
        if (data) {
            setSelectedDiscountName(data);
            setSelectedPriceListNumber(data);
        }
        // getCustomerData();
        // getFilteredCustomerData();
        // setIsLoading(false);
    }, []);

    // const onSelection = (event) => {
    //     setSelectRow(event.value);
    //     setSelectSaveData(event.value);

    // };
    const AddRow = async () => {
        setIsLoading(true);
        try {
            if (
                selectedPriceListNumber === null ||
        selectedPriceListNumber === "" ||
        selectedPriceListNumber === undefined
            ) {
                return;
            }
            if (
                selectedDiscountName === null ||
        selectedDiscountName === "" ||
        selectedDiscountName === undefined
            ) {
                return;
            }
            let strDist = "";
            if(customerData?.length>0){
                strDist = customerData
                    .map((item) => `${item.MASK_CUST_ID}`)
                    .join(",");
            }
            const res = await createAPIEndpointSalesDiscountAllocation().get(
                `${EndpointSalesDiscountAllocation.GetFilteredCustomerData}?CustId=${encodeURIComponent(strDist)}&PLNo=${selectedPriceListNumber?.PRICE_LIST_NO}&CompId=${auth.CompId}`
            );
            setSource(res.data);
            setCustPopUp(true);
        } catch (Ex) {
            console.log(Ex);
        } finally{
            setIsLoading(false);
        }
    };
    const onChange = (event) => {
        setSource(event.source);
        setTarget(event.target);
        console.log(event.source, event.target, "SourceTarget");
    };
    const btnOk_Click = () => {
        try {
            setCustomerData(target);
            setCustPopUp(false);
        } catch (ex) {
            console.log(ex);
        }
    };
    const itemTemplate = (item) => {
        return (
            <div>
                <div>{item.CUST_CODE}</div>
                <small>{item.CUST_NAME}</small>
            </div>
        );
    };
    return (
        <>
            {
                isLoading ? <Loader /> :
                    <>
                        <div className="col-12 pt-0 pb-4">
                            <div className="row">
                                <div className="col-lg-6 col-md-6 col-sm-12">
                                    <nav aria-label="breadcrumb">
                                        <ol className="breadcrumb mx-1">
                                            <li className="breadcrumb-item">
                                                <Link to="/masters/salesdiscountallocation">
                                                    Sales Discount Allocation
                                                </Link>
                                            </li>
                                            <li className="breadcrumb-item active" aria-current="page">
                                                Details
                                            </li>
                                        </ol>
                                    </nav>
                                </div>
                                <div className="col-lg-6 col-md-6 col-sm-12">
                                    <div className="float-end mb-2">
                                        <Link to="/masters/salesdiscountallocation">
                                            <button type="button" className="btn btn-outline-primary me-3">
                                                <Fa.FaLongArrowAltLeft className="backIcon" /> Back to All
                                                Records
                                            </button>
                                        </Link>
                                        <button className="btn btn-primary" onClick={saveData}>
                                            Save
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <section className="sales-box">
                                <div className="row d-flex justify-content-end align-items-end">
                                    <div className="col-lg-5 col-md-5 col-sm-12">
                                        <div className="d-block">
                                            <label className="form-label">Price List Number</label>
                                            <AutoComplete
                                                value={selectedPriceListNumber}
                                                suggestions={filteredPriceListNumber}
                                                completeMethod={filterPriceListNumber}
                                                field="PRICE_LIST_NO"
                                                onChange={(e) => {
                                                    setSelectedPriceListNumber(e.target.value);
                                                }}
                                                placeholder="Select a Price List Number"
                                                dropdown={true}
                                                forceSelection={true}
                                                disabled={Type==="View"?true:false}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-5 col-md-5 col-sm-12">
                                        <div className="d-block">
                                            <label className="form-label">Discount Name</label>
                                            <AutoComplete
                                                value={selectedDiscountName}
                                                suggestions={filteredDiscountName}
                                                completeMethod={filterDiscountName}
                                                field="DISCOUNT_NAME"
                                                onChange={(e) => {
                                                    setSelectedDiscountName(e.target.value);
                                                }}
                                                placeholder="Select Discount Name"
                                                dropdown={true}
                                                disabled={Type==="View"?true:false}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-2 col-md-2 col-sm-12">
                                        <div className="d-block">
                                            <button className="btn btn-primary" onClick={()=>AddRow()}>
                                                Add Row
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </section>
                            <section>
                                <h3>Records</h3>
                                <div className="col-lg-12 col-md-12 col-sm-12">
                                    <div className="DataTable">
                                        <DataTable
                                            value={customerData}
                                            rows={10}
                                            filterDisplay="row"
                                            // showGridlines
                                            stripedRows
                                            scrollHeight="80vh"
                                            scrollable
                                            paginator
                                        
                                            // selectionMode="checkbox"
                                            // selection={selectRow}
                                            // onSelectionChange={(e) => onSelection(e)}
                                            // selectAll={true}
                                        >
                                            {/* <Column
                                                selectionMode="multiple"
                                                header="Select All"
                                                headerStyle={{ width: "5rem" }}
                                            ></Column> */}
                                            <Column
                                                field="CUST_NAME"
                                                header="List of Customers"
                                                filter
                                                filterMatchMode="contains"
                                                filterPlaceholder="Search Here..."
                                            ></Column>
                                            <Column header="Action " body={(rowData) => (
                                                <button
                                                    type="button"
                                                    className="grid-icon"
                                                    onClick={() => {
                                                        DeleteCustDetailsData(rowData);
                                                    }}
                                                    disabled={rowData.isSelected === false}
                                                >
                                                    <Fa.FaTimes className="cancel"/>
                                                </button>
                                            )}></Column>
                                        </DataTable>
                                    </div>
                                </div>
                            </section>
                        </div>
                        <Dialog header="Information" visible={custPopUp} 
                            closable={false}
                            resizable={false}
                            draggable={false}>
                            <div className="col-lg-12 col-md-12 col-sm-12">
                                <div className="PickListPanel">
                                    <PickList
                                        dataKey="MASK_CUST_ID"
                                        source={source}
                                        target={target}
                                        breakpoint="768px"
                                        itemTemplate={itemTemplate}
                                        onChange={onChange}
                                        filter
                                        filterBy="CUST_NAME"
                                        sourceHeader="Available Customer(s)"
                                        targetHeader="Selected Customer(s)"
                                        sourceStyle={{ height: "24rem" }}
                                        targetStyle={{ height: "24rem" }}
                                    />
                                    {/* {getFormErrorMessage("target")} */}
                                </div>
                            </div>
                            <div className="col-lg-12 col-md-12 col-sm-12">
                                <div className="float-end mb-2 mt-4">
 
                                    <button className="btn btn-primary me-2" title="Ok" onClick={btnOk_Click}>
                                            Ok
                                    </button>
                                    <button className="btn btn-cancel-red" title="Cancel" onClick={()=>{setCustPopUp(false);}}>
                                           Cancel
                                    </button>
                                </div>
                            </div>
                        </Dialog>
                    </>
            }
        </>
    );
};

export default SalesDiscountAllocation;
